import { ApplicationType } from '@/app/shared/enums/operation/application-type.enum';
import { Model } from '@/app/shared/models/model';

export class ApplicationModel extends Model {
  public Name!: string;
  public Description!: string;
  public Url!: string;
  public IconUri!: string;
  public Type!: ApplicationType;
  public Code!: string;
}
